import { TTranslateFunction } from '@modules/localization/types/TranslateFunction';
import { TOperationExtensions } from '@rbx/docsite-utilities';

export default function getRateLimitMarkdown(
  translate: TTranslateFunction,
  rateLimits: TOperationExtensions['x-roblox-rate-limits'] & {
    perApiKeyOwner: {
      // eslint-disable-next-line camelcase
      max_in_period?: number;
    };
    perOauth2Authorization: {
      // eslint-disable-next-line camelcase
      max_in_period?: number;
    };
  },
) {
  if (!rateLimits) {
    return '';
  }

  /**
   * - **API key**: 60 requests per minute across all API keys for a user or group
   * - **OAuth 2.0**: 10 requests per minute per access token
   *
   * A custom description.
   *
   * Note: Rate limits can be lower during high-traffic periods. Certain endpoints have additional rate limits. [Learn more about rate limits](../limits).
   */

  const items = [
    rateLimits.perApiKeyOwner
      ? `- **${translate(`Label.ApiKey`)}**: ${translate(
          `Description.RateLimits.APIKey.${rateLimits.perApiKeyOwner.period}`,
          {
            limit: rateLimits.perApiKeyOwner.max_in_period
              ? rateLimits.perApiKeyOwner.max_in_period.toString()
              : (rateLimits.perApiKeyOwner.maxInPeriod?.toString() ?? ''),
          },
        )}`
      : '',
    rateLimits.perOauth2Authorization
      ? `- **${translate(`Label.OAuth2`)}**: ${translate(
          `Description.RateLimits.OAuth2.${rateLimits.perOauth2Authorization.period}`,
          {
            limit: rateLimits.perOauth2Authorization.max_in_period
              ? rateLimits.perOauth2Authorization.max_in_period.toString()
              : (rateLimits.perOauth2Authorization.maxInPeriod?.toString() ?? ''),
          },
        )}`
      : '',
    rateLimits.description ? `\n${rateLimits.description}` : '',
    `\n${translate('Description.RateLimitAsGuideline', {
      link: '/cloud/reference/rate-limits',
    })}`,
  ].filter(Boolean);

  return items.join('\n');
}
